import { MatchEventType } from 'shared/types/match-event';
import { VideoMarkerDto, VideoMarkerInsertDto } from 'modules/core/domain/interfaces/supabase/video-markers/dto';
import { VideoMarker, VideoMarkerDraft } from 'modules/video-markers/domain/interfaces';

export function mapVideoMarkerDraftToDto(draft: VideoMarkerDraft): VideoMarkerInsertDto {
  return {
    kind: draft.kind,
    tournament_id: draft.organizerId,
    match_id: draft.matchId,
    device_id: draft.deviceId,
    recorder: draft.recorder,
    event_id: draft.eventId,
    event_type: draft.eventType,
    match_period: draft.matchPeriod,
    match_second: draft.matchSecond,
    clock_running: draft.clockRunning,
    recording_ms: draft.recordingMs,
    recording_paused: draft.recordingPaused,
    recording_file: draft.recordingFile,
    streaming_ms: draft.streamingMs,
    precision_ms: draft.precisionMs,
    client_received_at: draft.clientReceivedAt,
    chronology_commit_at: draft.chronologyCommitAt,
    native_marker: draft.nativeMarker,
  };
}

export function mapVideoMarkerDto(dto: VideoMarkerDto): VideoMarker {
  return {
    id: dto.id,
    createdAt: dto.created_at,
    kind: dto.kind,
    organizerId: dto.tournament_id,
    matchId: dto.match_id,
    deviceId: dto.device_id,
    recorder: dto.recorder,
    eventId: dto.event_id,
    eventType: dto.event_type as MatchEventType | null,
    matchPeriod: dto.match_period,
    matchSecond: dto.match_second,
    clockRunning: dto.clock_running,
    recordingMs: dto.recording_ms,
    recordingPaused: dto.recording_paused,
    // `undefined` — стенд без миграции `20261009_video_markers_recording_file.sql`.
    recordingFile: dto.recording_file ?? null,
    streamingMs: dto.streaming_ms,
    precisionMs: dto.precision_ms,
    clientReceivedAt: dto.client_received_at,
    chronologyCommitAt: dto.chronology_commit_at,
    nativeMarker: dto.native_marker,
  };
}
